
export enum KeyboardShortcutsTitle{
    KeyboardShortcuts  = "Keyboard Shortcuts",
    ReferAndEarn       = "Refer And Earn"
  }